import React, { useEffect } from 'react';
import '../../App.css';
import Herosection from '../Herosection';
import Portafolio2 from '../Portafolio2';
import Footer from '../Footer';
import Towcol from '../Towcol';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      <Helmet>
        <meta charSet='utf-8' />
        <title>Tekins | Soluciones de TI y Ciberseguridad</title>
        <meta
          name='description'
          content='Tekins provee soluciones de ciberseguridad en la nube, software especializado y soporte técnico para empresas en Panamá y Estados Unidos.'
        />
        <meta name='robots' content='index, follow' />
      </Helmet>
      <Herosection />
      <Towcol />
      <Portafolio2 />
      <Footer />
    </>
  );
}

export default Home;
